import PropTypes from 'prop-types';
import Media from 'react-media';
import { css, etiColors, mediaQueries } from '@eti/styles';
import { ResultSetMetaData, TripRoute } from '@eti/types';
import { PRICE } from '../../../../../constants/searchFiltersConstants';
import { SelectedFilters } from '../../../constants/resultPropTypes';
import PriceSliderFilter from '../PriceSliderFilter';
import TravelTime from '../TravelTime';
import DepartureArrivalTime from '../DepartureArrivalTime';
import FiltersButtons from './FiltersButtons';
import NumberOfStops from './NumberOfStops';
import Airlines from './Airlines';

const wrapperForMultipleFiltersWithPartialWidthStyles = css`
  display: flex;
  flex-wrap: wrap;
`;

const partialWidthFilterStyles = css`
  @media ${mediaQueries.medium.up} {
    &:nth-child(odd) {
      margin-right: 15px;

      &::before {
        border-top: 1px dotted ${etiColors.grayScale[9]};
        content: '';
        display: block;
        margin-right: -15px;
      }

      html[dir='rtl'] & {
        margin-left: 15px;
        margin-right: 0;

        &::before {
          margin-left: -15px;
          margin-right: 0;
        }
      }
    }

    /* stylelint-disable no-descending-specificity */
    &:nth-child(even) {
      margin-left: 15px;

      &::before {
        border-top: 1px dotted ${etiColors.grayScale[9]};
        content: '';
        display: block;
        margin-left: -16px;
      }

      html[dir='rtl'] & {
        margin-left: 0;
        margin-right: 15px;

        &::before {
          margin-left: 0;
          margin-right: -16px;
        }
      }
    }
  }
`;

const SearchFilters = ({
  onClear,
  onDone,
  onFilter,
  resultSetMetaData: { marketingCarriers, priceRange, travelTimeRange },
  selectedFilters,
  searchRoutes,
}) => (
  <div>
    <Media query={mediaQueries.medium.down}>
      {(isMobile) => (
        <>
          <div className={wrapperForMultipleFiltersWithPartialWidthStyles}>
            <NumberOfStops
              className={partialWidthFilterStyles}
              isToggleable={isMobile}
              onFilter={onFilter}
              selectedFilters={selectedFilters}
            />
            <PriceSliderFilter
              className={partialWidthFilterStyles}
              isInitiallyExpanded={false}
              isToggleable={isMobile}
              onFilter={onFilter}
              range={priceRange}
              selectedValues={selectedFilters[PRICE]}
            />
          </div>
          <Airlines
            isToggleable={isMobile}
            marketingCarriers={marketingCarriers}
            onFilter={onFilter}
            selectedFilters={selectedFilters}
          />
          <div className={wrapperForMultipleFiltersWithPartialWidthStyles}>
            {searchRoutes.map((route, i) => (
              <DepartureArrivalTime
                className={partialWidthFilterStyles}
                destinationName={route.destination.cityName}
                index={i}
                isToggleable={isMobile}
                key={`${route.departureAt}-${route.origin.cityName}-${route.destination.cityName}`}
                onFilter={onFilter}
                originName={route.origin.cityName}
                selectedFilters={selectedFilters}
              />
            ))}
            <TravelTime
              className={partialWidthFilterStyles}
              isToggleable={isMobile}
              onFilter={onFilter}
              selectedFilters={selectedFilters}
              travelTimeRange={travelTimeRange}
            />
          </div>
          <FiltersButtons onClear={onClear} onDone={onDone} />
        </>
      )}
    </Media>
  </div>
);

SearchFilters.propTypes = {
  onClear: PropTypes.func,
  onDone: PropTypes.func,
  onFilter: PropTypes.func,
  resultSetMetaData: ResultSetMetaData,
  searchRoutes: PropTypes.arrayOf(TripRoute),
  selectedFilters: SelectedFilters,
};

export default SearchFilters;
